<script setup>
// Icon + term/detail list, in a SplitHeaderBlock (heading left, list right at
// from-md+ — jk-31 follow-up, matches Home's own "What We Do" section, which
// uses the same SplitHeaderBlock pattern). Each item is an "xl" Material
// Symbol beside a `<strong>term</strong>: detail` line. Icon names must be in
// the subset font's ICON_NAMES list (see scripts/subset-icon-font.mjs).
import Icon from '@/components/Icon.vue'
import SplitHeaderBlock from '@/components/SplitHeaderBlock.vue'

defineProps({
  block: { type: Object, required: true },   // { heading?, items: [{ icon?, term, detail }] }
})
</script>

<template>
  <SplitHeaderBlock :heading="block.heading || ''" class="icon-list">
    <div class="list">
      <div v-for="(item, i) in block.items || []" :key="i" class="item">
        <Icon v-if="item.icon" :name="item.icon" size="xl" class="icon" />
        <p><strong>{{ item.term }}</strong>: {{ item.detail }}</p>
      </div>
    </div>
  </SplitHeaderBlock>
</template>

<style lang="scss" scoped>
.icon-list {
  // Match ContentSection's section-label weight (500) rather than
  // SplitHeaderBlock's default bold h2 — this block sits alongside `section`
  // blocks on /about/vision-mission-and-values (Vision / Mission / Values
  // rows), and the three labels need to read identically. iconList is only
  // used on that page, so this override affects nothing else.
  :deep(.header h2) { font-weight: 500; }

  .list {
    display: flex;
    flex-direction: column;
    gap: $space-5;
    align-items: flex-start;
  }

  .item {
    width: 100%;
    display: flex;
    gap: $space-5;
    align-items: center;

    & + .item {
      border-top: 1px solid var(--color-border);
      padding-top: $space-5;
    }

    .icon {
      flex: none;
      // Default Icon colour (var(--color-ink)) — no override needed, was
      // var(--color-primary) before this pass.
    }

    p {
      margin: 0;
      font-size: $font-size-lg;
      line-height: $lh-base;
      color: var(--color-ink);
    }
  }
}
</style>
